import flatpickr from 'flatpickr'

document.addEventListener('DOMContentLoaded', function () {
    let dateInputs = document.querySelectorAll('input.picker')

    let config = {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "d.m.Y",
    }

    dateInputs.forEach(dateInput => {
        flatpickr(dateInput, config)
    })
})
